/**
 * The DeepSeek models this app exposes, and what each one is for.
 * Kept in `shared` so the picker in the UI and the validator on the server
 * can never drift apart.
 */

export const MODEL_IDS = ["deepseek-v4-flash", "deepseek-v4-pro"] as const;

export type ModelId = (typeof MODEL_IDS)[number];

export const DEFAULT_MODEL: ModelId = "deepseek-v4-flash";

export type ReasoningEffort = "low" | "medium" | "high";

export const REASONING_EFFORTS: readonly ReasoningEffort[] = [
  "low",
  "medium",
  "high",
] as const;

export interface ModelInfo {
  readonly id: ModelId;
  readonly label: string;
  /** One line the UI shows under the name, so you can pick without reading docs. */
  readonly blurb: string;
}

export const MODELS: readonly ModelInfo[] = [
  {
    id: "deepseek-v4-flash",
    label: "Flash",
    blurb: "Fast and cheap. Good for concept questions and quick derivations.",
  },
  {
    id: "deepseek-v4-pro",
    label: "Pro",
    blurb: "Slower, stronger. Use for long derivations and hard problem sets.",
  },
] as const;

export function isModelId(value: unknown): value is ModelId {
  return (
    typeof value === "string" && (MODEL_IDS as readonly string[]).includes(value)
  );
}
